import "./Spacer.css";

export default function Spacer() {
    return <div className="spacer" />;
}